/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


window.Vue = require('vue');
Vue.config.devtools = true;
import router from '@/js/routes.js';
import screenfull from 'screenfull';
Object.defineProperty(Vue.prototype, '$screenfull', { value: screenfull });

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('olMap', require('./components/map.vue').default);
Vue.component('treeView', require('./components/tree.vue').default);
Vue.component('ajax-form', require('./components/ajax-form.vue').default);
Vue.component('modal', require('./components/modal.vue').default);
Vue.component('delete-confirm', require('./components/delete-confirm.vue').default);
Vue.component('m-textarea', require('./components/textarea.vue').default);
Vue.component('m-textinput', require('./components/textinput.vue').default);
Vue.component('m-checkinput', require('./components/checkinput.vue').default);
Vue.component('m-select', require('./components/select.vue').default);

import { store } from './store/store'

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
if (document.getElementById('app')){
    const app = new Vue({
        router,
        el: '#app',
        store,
        data(){
            return {
                is_admin,
                dnc_count,
            };
        },
    });




    /*
    // event to make app fullscreen
    if (screenfull.enabled) {
        $('.fullscreen-toggle').click(function (event) {
            event.preventDefault();
            screenfull.toggle();
        });
    } else {
        // remove the toggle fullscreen link
        $('.fullscreen-toggle').remove();
    }
    */

    /*
    // close mobile navbar on click
    var navMain = $(".navbar-collapse"); // avoid dependency on #id
    // "a:not([data-toggle])" - to avoid issues caused
    // when you have dropdown inside navbar
    navMain.on("click", "a:not([data-toggle])", null, function () {
        navMain.collapse('hide');
    });
    // mp035 also add class based selector because one of my links
    // is a data-toggle, but I still want it to close the navbar
    navMain.on("click", ".collapse-navbar", null, function () {
        navMain.collapse('hide');
    });
    */

    $(document).ready(function(){
        // iOS web app full screen hacks.
        if(window.navigator.standalone == true) {
            // make all link remain in web app mode.
            $('a').click(function() {
                window.location = $(this).attr('href');
                return false;
            });
        }
    });

}
